import UserManagement from './main';

export const companyRoutes = [
  { name: 'User Management', path: '/company/user-management', render: () => <UserManagement /> },
];